export interface EditCalendarAccountParams {
  accountType: 'google' | 'zoom' | 'ms_teams';
  calendarName?: string;
  color?: string;
}
export enum UnlinkCalendarName {
  google = 'google',
  zoom = 'zoom',
  'ms-teams' = 'ms-teams',
}
